import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons/faInfoCircle';
import { Icon } from 'src/shared/components/icon';
import { Tooltip } from 'src/shared/components/tooltip';
export function Header({ description, tooltip }) {
    return (_jsx("div", { className: "flex items-center justify-between gap-12 px-5 py-4", children: _jsxs("p", { className: "flex items-center text-medium text-neutral-600", children: [description, _jsx(Tooltip, { text: tooltip, className: "ml-2", children: _jsx(Icon, { icon: faInfoCircle }) })] }) }));
}
